/**
 * GlobalLayout - Root layout that wraps all routes
 *
 * Renders the shared GlobalNav above every page via React Router's Outlet.
 */

import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { GlobalNav } from './GlobalNav'
import { useUserDataSync } from '../context/UserDataSyncContext'

const DETAIL_RE = /^\/(cpus|gpus|memory|storage|psus|cases|coolers|motherboards)\/[^/]+$/
const LIST_RE   = /^\/(cpus|gpus|memory|storage|psus|cases|coolers|motherboards)$/

function RouteChangeSync() {
  const location = useLocation()
  const { checkIfStale } = useUserDataSync()

  useEffect(() => {
    void checkIfStale()
  }, [location.pathname, checkIfStale])

  return null
}

export const GlobalLayout: React.FC = () => {
  const location = useLocation()
  const prevPathRef = useRef('')

  // Detect "detail → list" back navigation to slide in from the left
  const comingFromDetail =
    DETAIL_RE.test(prevPathRef.current) && LIST_RE.test(location.pathname)

  useEffect(() => {
    prevPathRef.current = location.pathname
  }, [location.pathname])

  return (
    <div className="min-h-screen flex flex-col">
      <RouteChangeSync />
      <GlobalNav />
      <div className="flex-1">
        {/* key re-mounts the wrapper on every navigation so the CSS animation re-fires */}
        <div key={location.key} className={comingFromDetail ? 'page-enter-from-left' : ''}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
